import React, { useState } from "react";
import { AiFillCloseCircle } from "react-icons/ai";
import "./update-profile-modal.css";
import { useDispatch } from "react-redux";
import { updateProfile } from "../../redux/apiCalls/profileApiCalls";

const UpdateProfileModal = ({ setUpdateProfile, profile }) => {
  const dispatch = useDispatch();
  const [username, setUsername] = useState(profile?.username);
  const [bio, setBio] = useState(profile?.bio);
  const [password, setPassword] = useState("");

  //Form submit handler
  const updateProfileSubmitHandler = (e) => {
    e.preventDefault();
    const updatedUser = { username, bio };
    if (password.trim() !== "") {
      updatedUser.password = password;
    }
    //@TO-Do send form data to server
    dispatch(updateProfile(profile?._id, updatedUser));
    setUpdateProfile(false)
  };

  return (
    <div className="update-profile">
      <form
        onSubmit={updateProfileSubmitHandler}
        className="update-profile-form "
      >
        <div className="update-profile-page-form-row-color"></div>
        <abbr title="close">
          <AiFillCloseCircle
            onClick={() => setUpdateProfile(false)}
            className="update-profile-form-close"
          />
        </abbr>
        <h4>تحديث بيانات المستخدم</h4>
        <div className="update-profile-page-form-row">
          <input
            type="text"
            placeholder="الاسم"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <input
            type="text"
            placeholder="نبذه عن المستخدم "
            value={bio}
            onChange={(e) => setBio(e.target.value)}
          />
          <input
            type="password"
            placeholder="الرقم السرى "
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <div className="update-profile-page-form-row">
          <button type="submit" className="update-profile-page-btn">
            تحديث البروفايل
          </button>
        </div>
        <div className="update-profile-page-form-row-color-end"></div>
      </form>
    </div>
  );
};

export default UpdateProfileModal;
